import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-welcome-screen',
  templateUrl: './welcome-screen.component.html',
  styleUrls: ['./welcome-screen.component.scss']
})
export class WelcomeScreenComponent implements OnInit {
  @Output() exploreProducts = new EventEmitter<void>();
  @Output() languageChanged = new EventEmitter<string>();

  heroImage = 'assets/ahoi/pancake.png'; // Pancakes image
  currentLanguage = 'de';
  
  languages = [
    { code: 'de', label: 'DE' },
    { code: 'en', label: 'EN' }
  ];

  constructor(
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    const languageValue = localStorage.getItem('langOfApp');
    if(languageValue){
      this.currentLanguage = languageValue
    } else {
      this.currentLanguage = this.translate.currentLang;
    }
    
    // Set default language to German
    this.translate.setDefaultLang(this.currentLanguage);
    this.translate.use(this.currentLanguage);
  }

  onStartOrdering() {
    this.exploreProducts.emit();
    // Let the parent component handle navigation
  }

  onLanguageChange(languageCode: string) {
    this.currentLanguage = languageCode;
    this.translate.use(languageCode);
    this.languageChanged.emit(languageCode);
  }

  isLanguageActive(languageCode: string): boolean {
    return this.currentLanguage === languageCode;
  }
}